import React from 'react'
import { Card, Col, Row, Typography } from 'antd'

import TotalNoOfTeams from 'component/DashboardCard/TotalNoOfTeams'
import TemplateStates from 'component/DashboardCard/TemplateStatsCard'
import ContactOverviewCard from 'component/DashboardCard/ContactOverviewDashboardCard'
import ConversationPerUserCard from 'component/DashboardCard/ConversationPerUserCard'
import UserCreated from 'component/DashboardCard/UserCreatedCard'
import ConversationStatsCard from 'component/DashboardCard/ConversationStatsCard'
import IntegrationStatsCard from 'component/DashboardCard/IntegrationStatsCard'

interface PropType {
	clientId: string | undefined
}
const { Text } = Typography
const DashboardView: React.FC<PropType> = ({ clientId }) => {
	return (
		<Row justify='space-between' gutter={[8, 16]}>
			<Col span={24}>
				<TotalNoOfTeams clientId={clientId} />
			</Col>
			<Col span={5}>
				<Card title="User's Conversation Stats">
					<Text>Coming Soon....!</Text>
				</Card>
			</Col>
			<Col span={5}>
				<Card title='Agent Feedbacks Stats'>
					<Text>Coming Soon....!</Text>
				</Card>
			</Col>
			<Col span={24}>
				<IntegrationStatsCard clientId={clientId} />
			</Col>
			<Col span={14}>
				<UserCreated clientId={clientId} />
			</Col>

			<Col span={24}>
				<ContactOverviewCard clientId={clientId} />
			</Col>
			<Col span={24}>
				<TemplateStates clientId={clientId} />
			</Col>
			<Col span={14}>
				<ConversationStatsCard clientId={clientId} />
			</Col>
			{clientId && (
				<Col span={10}>
					<ConversationPerUserCard clientId={clientId} />
				</Col>
			)}
		</Row>
	)
}

export default DashboardView
